import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SearchBox from './SearchBox';
import SortBox from './SortBox';
import __ from '../../helpers/translation';

const propTypes = {
  //searchCallback: PropTypes.func.isRequired,
  template: PropTypes.func.isRequired,
  items: PropTypes.array,
  searchText: PropTypes.string,
  sortText: PropTypes.string,
  searchField: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
  loading: PropTypes.bool,
  itemsEmpty: PropTypes.string,
  searchEmpty: PropTypes.string,
};

const sortMethods = {
    sort_by_date_desc: { method: (a, b) => (b.id - a.id) },
    sort_by_date_asc: { method: (a, b) => (a.id - b.id) },
    sort_by_name_asc: { method: (a, b) => (a.name > b.name ? 1 : -1) },
    sort_by_name_desc: { method: (a, b) => (a.name > b.name ? -1 : 1) },
};

class  SearchableList extends Component {

    constructor (props) {
      super(props);
      this.searchEmpty = props.searchEmpty ? props.searchEmpty : __('app.general.search_no_results');
      this.itemsEmpty = props.itemsEmpty ? props.itemsEmpty : __('app.general.no_selections');
      this.searchField = props.searchField ? props.searchField : null;

      this.state = {
        'searchText': props.searchText ? props.searchText : '',
        'sortText': props.sortText ? props.sortText : '',
        'items': props.items ? props.items : [],
        'filteredItems': [],
        'loading': props.loading ? props.loading: false
      };
    }

    filteredItems() {

      let rows = [];
      //console.log(this.state);
      for(let i = 0; i < this.state.filteredItems.length; i++){
        rows.push(
          this.item(this.state.filteredItems[i])
        );
      }
          
      return rows.length ? rows : this.searchEmpty;
    }

    items() {
      let rows = [];
      
      for(let i = 0; i < this.state.items.length; i++){
        rows.push(
          this.item(this.state.items[i])
        );
      }
          
      return rows.length ? rows : this.itemsEmpty;
    }

    item(item){
      //const ItemTemplate = ;
      return this.props.template(item);
    }

    searchItems(searchText,sortText=null){

      let items = this.state.items;
      let filteredItems = items.filter(item => {
        if(!this.searchField || !searchText){
          return true;
        }

        return item[this.searchField].toLowerCase().includes(searchText.toLowerCase())  
      });

      sortText = (sortText)?sortText:this.state.sortText
      if (sortText) {
        filteredItems = filteredItems.sort(sortMethods[sortText].method);
      }

      this.setState({
        'filteredItems' : filteredItems,
        'searchText': searchText,
        'sortText': sortText
      });
    }

    sortItems(sortText){

      this.searchItems(this.state.searchText, sortText)
    }

    render () {
        return (

          <Fragment>
            <SearchBox 
                callback={(text) => this.searchItems(text)}
                disabled={!this.state.items || this.state.items.length < 3}
                searchText={this.state.searchText}
            />
            <SortBox 
                callback={(text) => this.sortItems(text)}
                disabled={!this.state.items || this.state.items.length < 3}
                sortText={this.state.sortText}
            />
            { 
              this.state.loading ?
              (
                <div className="d-block">
                  { __('app.general.loading') }
                </div>
              ) :
              (
                (this.state.searchText || this.state.sortText) ? this.filteredItems() : this.items()
              )
            }
          </Fragment>

        )
    }
}

SearchableList.propTypes = propTypes;

export default SearchableList;
